import { addToast, Button } from '@octano/global-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Col, Row } from 'reactstrap';
import { TranslationsKeys } from '../../../../locales/translations';
import { finantialOthersUpdateRequest } from '../api';
import { useFinantialOthersState } from '../hooks/useFinantialOthersState';
import FinantialOtherCertificates from './FinantialOtherCertificates';
import { FinantialOtherPaymentByAcademicLevel } from './FinantialOtherPaymentByAcademicLevel';
import FinantialOtherPetitions from './FinantialOtherPetitions';
import { useFinantialOthersLoader } from './FinantialOthersLoader';

function FinantialOthersContent() {
  const { t } = useTranslation(
    TranslationsKeys.CONFIGURATION_FIANANTIAL_OTHERS,
  );
  const {
    certificateTypesState,
    petitionTypesState,
    academicLevelsPriceState,
  } = useFinantialOthersState();
  const { refresh } = useFinantialOthersLoader();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    const { error } = await finantialOthersUpdateRequest({
      certificateTypes: certificateTypesState,
      petitionTypes: petitionTypesState,
      academicLevels: academicLevelsPriceState,
    });
    if (!error) {
      addToast({
        icon: 'success',
        color: 'success',
        text: t('onSaveSuccess'),
      });
      refresh();
    } else
      addToast({
        icon: 'error',
        color: 'danger',
        text: t('onSaveError'),
      });
    setLoading(false);
  };

  return (
    <Card className="p-4">
      <form onSubmit={onSubmit}>
        <Row>
          <Col sm={12}>
            <p className="fs-14 text-medium mb-3">{t('description')}</p>
          </Col>
          <Col sm={12}>
            <FinantialOtherCertificates />
          </Col>
          <Col sm={12}>
            <FinantialOtherPetitions />
          </Col>
          <Col sm={12}>
            <FinantialOtherPaymentByAcademicLevel />
          </Col>
          <Col sm={12}>
            <Button
              type="submit"
              text={t('save')}
              size="lg"
              className="float-right mt-5"
              disabled={loading}
              loading={loading}
            />
          </Col>
        </Row>
      </form>
    </Card>
  );
}

export default FinantialOthersContent;
